import {
    Center,
    Container,
    Group,
    Stack
} from "@mantine/core";

import {applications} from "./data";
import {config} from "../../../config";
import {FlexiSignInButton} from "@flexinet/ui-components";
import {ApplicationTile} from "../components/ApplicationTile.tsx";
import {internalUrl} from "../../../lib/internalUrl.ts";


export const IndexPage = () => {

    const activeApplications = applications.filter(item => item.active === true)


    return (
        <Container>

            <Stack style={{marginTop: 'var(--mantine-spacing-xl)'}}>
                {activeApplications.map(application => {
                    return <ApplicationTile key={application.name} application={application}/>
                })}
            </Stack>


            <Center>
                <Stack gap={"xl"} my={'xl'}>
                    <Group justify={'center'}>

                        <FlexiSignInButton
                            size={'xl'}
                            onClick={() => window.location.assign(internalUrl(config.platform.portal + '/sign-in', {campaign: 'hero-signin'}))}/>

                    </Group>
                </Stack>
            </Center>
        </Container>

    );
};
